import React from 'react';
import './index.scss';

function Contact() {
  return (
    <div className="section contact" id="contact">
        <div className="anchor-wrapper">
            <div className="anchor"/>
        </div>
        <div className="inner">
            <h1>contact</h1>
            <div className="content">
                mail: <a href="mailto:troelsdamgaard@gmail.com">troelsdamgaard@gmail.com</a><br/>
                phone: +45 2858 0628
            </div>
        </div>
    </div>
  );
}

export default Contact;
